export const ROUTES = {
    USER_MANAGEMENT: 'USER',
}